









































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

import EmptyData from '../../../EmptyData/EmptyData.vue'
import { AColGrid, KeyFn, ListConfig, ListDirection, ListItem, SearchFn } from './logic/types'

@Component({
  components: {
    EmptyData,
  },

  data: () => ({
    ListDirection,
  }),
})
export default class List extends Vue {
  @Prop() readonly config!: ListConfig

  searchText = ''

  paginationIndex = 1

  renderList = true

  get calculateSpans():AColGrid {
    const defaultGrid = {
      xs: 24,
      md: 12,
      lg: 8,
      xl: 6
    }

    if (this.config.grid !== undefined) {
      return this.config.grid
    } else {
      if (this.config.direction === ListDirection.Vertical) {
        return {
          span: 24
        }
      } else {
        return defaultGrid
      }
    }
  }

  get searchFn(): SearchFn | undefined {
    return this.config.searchFn
  }

  get paginateBy(): number {
    return this.config.paginateBy || this.items.length
  }

  get sliceFromIndex(): number {
    return (this.paginationIndex - 1) * this.paginateBy
  }

  get paginationTotal(): number {
    return Math.ceil(this.items.length / this.paginateBy)
  }

  // eslint-disable-next-line id-blacklist
  get items(): Array<ListItem> {
    const { searchFn } = this
    return this.searchText && searchFn ? [ ...this.config.data ]
      .filter((element, index) => searchFn(element, index, this.searchText)) : this.config.data
  }

  get paginatedItems(): Array<ListItem> {
    return this.items.slice(this.sliceFromIndex, this.sliceFromIndex + this.paginateBy)
  }

  get keyFn(): KeyFn {
    return this.config.keyFn
  }

  get direction(): ListDirection {
    return this.config.direction || ListDirection.Vertical
  }

  get showTopBar(): boolean {
    return this.$slots.title !== undefined || this.searchFn !== undefined
  }

  get emptyListData(): { 'icon': string, 'text': string } {
    if (this.searchText !== '') {
      return { icon: 'not-found', text: this.$t('pi_list_not_found') as string }
    }

    return { icon: 'list-empty', text: this.$t('pi_list_empty') as string }
  }

  get showPagination(): boolean {
    return this.config.paginateBy !== undefined && this.items.length >= this.config.paginateBy
  }

  @Watch('paginationIndex')
  onPaginate(): void {
    this.renderList = false
    this.$nextTick(() => {
      this.renderList = true
    })
  }

  @Watch('paginatedItems')
  updatedPaginationIndex(value: Array<ListItem>): void {
    if (value.length === 0 && this.paginationIndex > 1) {
      this.paginationIndex--
    }
  }

  created(): void {
    this.$i18n.mergeLocaleMessage('ru', {
      pi_list_empty: 'Список пуст',
      pi_list_not_found: 'Не найдено',
      field_search_text_placeholder: 'Поиск',
    })
    this.$i18n.mergeLocaleMessage('en', {
      pi_list_empty: 'List is empty',
      pi_list_not_found: 'Not found',
      field_search_text_placeholder: 'Search',
    })
  }
}
